"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var themes_1 = require("./themes");

var getPadding = function getPadding(props) {
  var _a, _b, _c, _d, _e, _f;

  if (props.padding === undefined || props.padding === null) return "0 " + (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.padding, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.default.padding) + "px";
  if (!props.padding) return 0;
  if (typeof props.padding === 'string') return props.padding;
  if (typeof props.padding === 'number') return props.padding + "px";
  return (_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.default) === null || _e === void 0 ? void 0 : _e.padding, _f !== null && _f !== void 0 ? _f : themes_1.defaultTheme.default.padding) + 'px';
};

var getWidth = function getWidth(props, threshold) {
  if (threshold && props[threshold] !== undefined) {
    var thresholdWidth = props[threshold];
    if (typeof thresholdWidth === 'string') return thresholdWidth;

    if (typeof thresholdWidth === 'number') {
      return thresholdWidth + "%";
    }
  }

  if (props.width) {
    if (typeof props.width === 'string') return props.width;
    if (typeof props.width === 'number') return props.width + "%";
  }

  return threshold ? null : 'auto';
};

var getFlex = function getFlex(props, threshold) {
  var width = getWidth(props, threshold);

  if (width === 'none' || width === 'hidden') {
    return 'display: none;';
  }

  if (width === 'flex') {
    return 'display: flex; flex: 1;';
  }

  if (width === 'auto') {
    return 'display: flex; flex: 0 0 auto;';
  }

  if (width && width.indexOf(' ') > 0) {
    return "display: flex; flex: " + width;
  }

  return width && "display: flex; flex: 0 0 " + width + ";";
};

exports.Column = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  flex: ", ";\n  ", "\n  box-sizing: border-box;\n  align-items: ", ";\n  justify-content: ", ";\n\n  @media (min-width: ", "px) {\n    ", "\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n"], ["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  flex: ", ";\n  ", "\n  box-sizing: border-box;\n  align-items: ", ";\n  justify-content: ", ";\n\n  @media (min-width: ", "px) {\n    ", "\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n\n  @media (min-width: ", "px) {\n    ", ";\n  }\n"])), getPadding, function (_a) {
  var flex = _a.flex;
  return !flex ? '0 0 auto' : typeof flex === 'boolean' ? 1 : flex;
}, function (props) {
  return getFlex(props, 'xs');
}, function (_a) {
  var alignItems = _a.alignItems,
      align = _a.align;
  return alignItems || align || 'unset';
}, function (_a) {
  var justify = _a.justify;
  return justify || 'unset';
}, function (props) {
  var _a, _b, _c;

  return _c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b.sm, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.thresholds.sm;
}, function (props) {
  return getFlex(props, 'sm');
}, function (props) {
  var _a, _b, _c;

  return _c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b.md, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.thresholds.md;
}, function (props) {
  return getFlex(props, 'md');
}, function (props) {
  var _a, _b, _c;

  return _c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b.lg, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.thresholds.lg;
}, function (props) {
  return getFlex(props, 'lg');
}, function (props) {
  var _a, _b, _c;

  return _c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b.xl, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.thresholds.xl;
}, function (props) {
  return getFlex(props, 'xl');
}, function (props) {
  var _a, _b, _c;

  return _c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b.xxl, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.thresholds.xxl;
}, function (props) {
  return getFlex(props, 'xxl');
});
var templateObject_1;